import { Component, OnInit, OnDestroy, Renderer2, Inject } from '@angular/core';
import { StartUpConfigUiService, ValidationUiService, InsurersValidationService, CommonService, CjProcessNavUiService, SwProcessStateService, PostalCodeValidationService, ProcessCounterService, AyudaClientService, CjProcessTrackingUiService, GtmDatalayerUiService, SwProcessService, LocalDataCacheService, CookieService } from '../Services';
import { InitialConfigModel, ContractType, PersonType, AdditionalInsurers, UpaPluginsModel, UpaUserProfileDataModel } from '../models';
import { Gender, Relationship } from '../enums';
import { ActivatedRoute, Router } from '@angular/router';
import { counter } from '../constants';
import { Subscription } from 'rxjs';
import { AyudaService, AyudaEventService } from 'ras-ayuda';
import { take } from 'rxjs/operators';
import { DOCUMENT } from '@angular/common';
declare function maskingDob(): any;

@Component({
  selector: 'app-layout',
  host: { class: 'body-prop' },
  templateUrl: './layout.component.html'
})
export class LayoutComponent implements OnInit, OnDestroy {

  private ayudaChannelSubscription: Subscription;
  private ayudaFormEventSubscription: Subscription;
  constructor(private renderer: Renderer2, private gtmDataLayerUiService: GtmDatalayerUiService,
    private cjProcessTrackingUiService: CjProcessTrackingUiService, private route: Router,
    private ayudaEventService: AyudaEventService, private ayudaClientService: AyudaClientService,
    private ayudaService: AyudaService, private CounterService: ProcessCounterService,
    private postalCodeValidationService: PostalCodeValidationService,
    private swProcessStateService: SwProcessStateService,
    private customerJourneyService: CjProcessNavUiService,
    private commonService: CommonService,
    private insurersValidationService: InsurersValidationService,
    private configUiService: StartUpConfigUiService,
    private validationUiService: ValidationUiService,
    private swProcessService: SwProcessService,
    private cookieService: CookieService,
    private activatedRoute: ActivatedRoute,
    @Inject(DOCUMENT) private document: Document
  ) { }
  public initialConfig: InitialConfigModel;
  public contractType: ContractType = new ContractType();
  public policyHolder: PersonType = new PersonType();
  public isSw = false;
  public baseMakeImageUrl: string;
  public isPrivacyPolicyChecked = false;
  public isPrivacyPolicyCollapsed = false;
  isAyudaDisable?: boolean = true;
  currentYear: number;
  isMobileApp: boolean;
  isUpaProfile: boolean = false;
  upaPlugings: UpaPluginsModel;
  upaUserProfileDataModel: UpaUserProfileDataModel
  isUserLoggedIn: boolean = false;
  isUserAlreadyLogin: boolean = false;
  isComponentLoadSucessfully: boolean = false;
  isErrorInLoginOrRegistrationInUPA: boolean = false;
  isSegurosUser: boolean = false;
  cjSubmittedWithErrors: boolean = false
  ngOnInit() {
    this.document.getElementById('count-plus')?.addEventListener('click', function () {
      maskingDob();

    });
    document.getElementById('count-minus')?.addEventListener('click', function () {
      maskingDob();
    });
    this.configUiService.sessionInfo$.subscribe({
      next: (sessionInfo) => {
        this.isMobileApp = sessionInfo.isMobileApp
      }
    });

    this.configUiService.initialConfig$.subscribe({
      next: (initialConfig) => {
        this.isSegurosUser = location.hostname.includes('seguros.es') || location.hostname.includes('segurostest.es') || (initialConfig.whiteLabel != null && initialConfig.whiteLabel.toLowerCase().includes('seguros.es'));
        this.initialConfig = initialConfig;
        this.baseMakeImageUrl = initialConfig.urlConfig.baseImageUrl + "cj/";
      }
    });
     this.contractType.policyHolder.length === 1;
    this.postalCodeValidationService.province$.subscribe({
      next: (zip) => {
        if (zip) {
          this.contractType.province = zip.provinceName;
          this.contractType.postalCode = zip.postalCode;
        }
        else {
          this.contractType.province = null;
          this.contractType.postalCode = null
        }
      }
    })

    this.initializeAyuda();

    const cSig = this.activatedRoute.snapshot.queryParamMap.get('c-sig');
    this.customerJourneyService.setCSig(cSig);

    if (this.route.url.indexOf("modifica-tus-datos") > -1) {
      //(document.getElementsByClassName('help-button')[0] as HTMLElement).style.display = 'none';
      this.swProcessStateService.initSwProcess().subscribe();
      this.CounterService.processCounter(counter.SectionWise).subscribe();
      this.swProcessStateService.swProcessModel$.subscribe(swInput => {
        if (swInput != null && swInput.noOfPerson == null && this.route.url.indexOf("utm_source=callcenter") < 0) {
          this.redirectToCms();
        }
        this.contractType = swInput;
        this.isSw = true
        this.swProcessStateService.setisSW(this.isSw);

      })
    }
    else {
      this.contractType.policyHolder.push(this.policyHolder);
      this.CounterService.processCounter(counter.InsuredSection).subscribe();
      this.cjProcessTrackingUiService.initIpTracking();
      this.gtmDataLayerUiService.initGtmDatalayer(this.configUiService.sessionInfo$).subscribe();
    }
    this.currentYear = new Date().getFullYear();
    //this.addJsToElement("assets/js/inputmask.js");
    //this.addJsToElement("assets/js/dobValidation.js");

    this.configUiService.deferredConfig$.pipe(take(1)).subscribe({
      next: (deferredConfig) => {
        this.upaPlugings = deferredConfig.upaPluginsModel;
        if (!this.upaPlugings)
          return;


        if (this.upaPlugings?.isEnabled && !this.isSw) {
          this.appendUpaLoginTrigger(this.upaPlugings.isMobileDevice);
          this.addTriggerEventListiner();
        }
      }
    });
  }


  private redirectToCms(): void {
    this.configUiService.cmsUrl$.pipe(take(1)).subscribe(cmsUrl => {
      this.document.location.href = cmsUrl;
    });
  }

  addInsurer() {
    let insurer = new PersonType();
    this.contractType.policyHolder.push(insurer);
    this.insurersValidationService.addInsurer();
  }
  removeInsurer() {
    this.contractType.policyHolder.pop();
    this.insurersValidationService.removeInsurer();
  }
  submitGenderAnswer(gender: string) {
    this.contractType.policyHolder[0].gender = gender == 'Male' ? Gender.Male : Gender.Female;
  }
  submitPrimaryDOB(dob: string) {
    this.contractType.policyHolder[0].birthDate = this.commonService.formatDate(dob);
    this.contractType.policyHolder[0].number = "1";
    if(this.cjSubmittedWithErrors) {
      this.validationUiService.isValid(this.contractType, this.isPrivacyPolicyChecked)
    }
  }
  addInsurers(insurers: AdditionalInsurers) {
    this.contractType.policyHolder[insurers.index + 1].birthDate = this.commonService.formatDate(insurers.date)
    this.contractType.policyHolder[insurers.index + 1].number = (insurers.index + 2).toString();
    this.contractType.policyHolder[insurers.index + 1].relationshipWithPolicyHolder = Relationship.Other
  }
  submitPostalCode(postalCode: string) {
    this.validationUiService.predictZipCode(postalCode);
    if(this.cjSubmittedWithErrors) {
      this.validationUiService.isValid(this.contractType, this.isPrivacyPolicyChecked)
    }
  }
  submitTelePhone(telePhone: string) {
    this.contractType.phone = telePhone;
    if(this.cjSubmittedWithErrors) {
      this.validationUiService.isValid(this.contractType, this.isPrivacyPolicyChecked)
    }
  }
  submitEmail(email: string) {
    this.contractType.emailAddress = email;
    if(this.cjSubmittedWithErrors) {
      this.validationUiService.isValid(this.contractType, this.isPrivacyPolicyChecked)
    }
  }
  submitPrivacyPolicy(isChecked: boolean) {
    this.isPrivacyPolicyChecked = isChecked;
    if(this.cjSubmittedWithErrors) {
      this.validationUiService.isValid(this.contractType, this.isPrivacyPolicyChecked)
    }
  }
  submitAnswer() {
    if (this.upaPlugings?.isEnabled && !this.isUserAlreadyLogin) {
      this.isPrivacyPolicyChecked = true;
    }

    if (this.validationUiService.isValid(this.contractType, this.isPrivacyPolicyChecked, this.upaPlugings?.isEnabled)) {
      this.cjSubmittedWithErrors = false;
      if (this.upaPlugings?.isEnabled && !this.isUserAlreadyLogin) {
        this.openUpaModal();
      } else {
        this.submitContract();
      }
    } else {
      this.gtmDataLayerUiService.customerjourneyerror().pipe(take(1)).subscribe({
        next: () => {
          this.gtmDataLayerUiService.setCjError(null, true);
          this.cjSubmittedWithErrors = true;
        }
      });
    }
  }

  submitContract() {
    this.gtmDataLayerUiService.saveAnswerDataLayerEvent(this.contractType).pipe(take(1)).subscribe({
      next: () => {
        this.customerJourneyService.postCjInputResponse(this.contractType);
      }
    });
  }

  submitSWAnswer() {
    if (this.upaPlugings?.isEnabled && !this.isUserAlreadyLogin) {
      this.isPrivacyPolicyChecked = true;
    }
    if (this.validationUiService.isValid(this.contractType, this.isPrivacyPolicyChecked, this.upaPlugings?.isEnabled)) {
      this.cjSubmittedWithErrors = false;
      if (this.upaPlugings?.isEnabled) {
        this.swProcessService.isRiskAlter(this.contractType).subscribe(res => {
          if (res && this.cookieService.get("verifieduserInfo") == '') {
            this.openUpaModal();
          } else {
            this.submitSWContract();
          }
        })
      } else {
        this.submitSWContract();
      }
    } else{
      this.cjSubmittedWithErrors = true;
    }
  }

  submitSWContract() {
    this.swProcessStateService.setCSig(this.initialConfig.clientSignature);
    this.swProcessStateService.submitSwInput(this.contractType);
  }
  private alignAyuda(): void {
    // TODO 1: Remove this temp fix once fixed in library
    try {
      if (window.innerWidth > 768) {
        (document.getElementsByClassName('help-button')[0] as HTMLElement).style.left = (window.innerWidth - 1224) / 2 + 'px';
      }
    } catch (e) { }
  }
  private initializeAyuda(): void {
    this.alignAyuda();

    const defSub = this.configUiService.deferredConfig$.subscribe({
      next: (value) => {
        const ayudaSetting = value && value.ayudaSetting;
        //TODO:In Case of WhatsApp
        this.isAyudaDisable = !ayudaSetting ? false : (ayudaSetting.isChatEnabled || ayudaSetting.isTelephoneEnabled || ayudaSetting.isEmailEnabled);

        if (!this.isAyudaDisable) {
          (document.getElementsByClassName('help-button')[0] as HTMLElement).style.display = 'none';
        }

        if (!ayudaSetting) {
          return;
        }
        setTimeout(() => {
          this.ayudaService.updateConfig({
            channelVisibility: {
              isChatEnabled: ayudaSetting.isChatEnabled,
              isCMBEnabled: ayudaSetting.isTelephoneEnabled,
              isEmailEnabled: ayudaSetting.isEmailEnabled,
              isWhatAppEnabled: ayudaSetting.isWhatsAppEnabled
            }
          });

          if (defSub) {
            defSub.unsubscribe();
          }
        }, 800);
      }
    })

    this.ayudaChannelSubscription = this.ayudaEventService.channelSelection$.subscribe({
      next: (event) => {
        this.ayudaClientService.handleChannelSelection(event.channel);
      }
    });

    this.ayudaFormEventSubscription = this.ayudaEventService.formSubmitEvent$.subscribe({
      next: (event) => {
        this.ayudaClientService.handleFormRequest(event);
      }
    });
  }
  TogglePrivacyPolicy() {
    this.isPrivacyPolicyCollapsed = !this.isPrivacyPolicyCollapsed;
    console.log(this.isPrivacyPolicyCollapsed)
  }
  addJsToElement(src: string): HTMLScriptElement {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    this.renderer.appendChild(document.body, script);
    return script;
  }

  hideHelpIfOpen() {
    let help_btn = document.getElementsByClassName("help-button-btn")[0];
    if (help_btn) {
      help_btn.setAttribute("style", "opacity: 1;");
    }
    let help_wrpr = document.getElementsByClassName("help-wrapper")[0];
    if (help_wrpr) {
      if (window.innerWidth > 768) {
        help_wrpr.classList.remove("in");
        help_wrpr.classList.remove("desktop");
      }
      else {
        help_wrpr.classList.remove("in");
        help_wrpr.classList.remove("mobile");
      }
    }
  }

  appendUpaLoginTrigger(isMobileDevice: boolean) {
    let tagId = 'upa-login-trigger';
    const tagName = document.getElementById(tagId)
    const customElement = document.createElement('webc-login-trigger')
    customElement.setAttribute("light-icon", "true")
    customElement.setAttributeNode(document.createAttribute('allow-save-comparative-data'));
    customElement.setAttributeNode(document.createAttribute('redirect'));
    customElement.setAttribute("product-id", '23')
    tagName.appendChild(customElement);
  }

  addTriggerEventListiner() {
    var loginTrigger: any = document.querySelector('webc-login-trigger');
    if (loginTrigger) {
      loginTrigger.addEventListener("finish", (e: any) => {

        if (!e)
          return;
        if (!e.detail)
          return;


        let interval = setInterval(() => {
          const trigger: any = document.querySelector("webc-login-trigger")
          if (trigger) {
            const upaProfileloaded: any = trigger.shadowRoot.getElementById("notification-bubble")
            if (upaProfileloaded) {
              clearInterval(interval)
              this.isUpaProfile = true
            } else {
              this.isUpaProfile = false
            }
          }
        }, 1000);

        //SSO-This event triggered by user icon and it trigger everytime (Login/registration from email/Social)
        if (e.detail[0].step == "SSO-header" && e.detail[0].data.access == "login-header" && e.detail[0].status == true) {
          this.isUserLoggedIn = true;
          this.isUserAlreadyLogin = true;
          this.gtmDataLayerUiService.upaLoginEvent(e.detail[0].data.userAccountID).subscribe()
          this.upaUserProfileDataModel = e.detail[0].data
          this.CounterService.processCounter('rs.upa.cj.sso.qv-logged-in').subscribe((res) => { })
          this.isComponentLoadSucessfully = true;
        }
      })

      loginTrigger.addEventListener("logout", (e: any) => {
        //save Counter on logout event
        this.CounterService.processCounter("rs.upa.c-salir.Q1").subscribe((res) => { })
        this.upaUserProfileDataModel = new UpaUserProfileDataModel();
        this.isUserLoggedIn = true;
        this.isUserAlreadyLogin = false;
        this.isUpaProfile = false
      })


    }
  }

  addUpaLoginEventListner() {
    document.querySelector('webc-login').addEventListener("finish", (e: any) => {
      if (!e)
        return;

      if (!e.detail)
        return;


      switch (e.detail[0].step) {
        case "facebook-sso-step":
        case "google-sso-step":
          //if user already register and came to login again for social user.
          if (e.detail[0].data.access == "login-rrss" && e.detail[0].status) {
            this.isUserLoggedIn = true;
            this.isUserAlreadyLogin = true;
            this.submitEmail(e.detail[0].data.email);
            if (!this.isSw) {
              this.submitContract()
            } else {
              this.submitSWContract()
            }

            this.CounterService.processCounter("rs.upa.cj.p-recepcion.success-cajaUPA").subscribe((res) => { })

          }
          break;
        case "access-email-step":
          //if user already register and came to login again for email type.
          if (e.detail[0].data.access == "login" && e.detail[0].status) {
            this.isUserLoggedIn = true;
            this.isUserAlreadyLogin = true;
            this.submitEmail(e.detail[0].data.email);
            if (!this.isSw) {
              this.submitContract()
            } else {
              this.submitSWContract()
            }

            this.CounterService.processCounter("rs.upa.cj.p-recepcion.success-cajaUPA").subscribe((res) => { })
          }
          break;
        case "SSO":
          //SSO, already login in all user account types
          if (e.detail[0].data.access == "login" && e.detail[0].status) {
            this.isUserLoggedIn = true;
            this.isUserAlreadyLogin = true;
            this.submitEmail(e.detail[0].data.email);
            if (!this.isSw) {
              this.submitContract()
            } else {
              this.submitSWContract()
            }

            this.CounterService.processCounter("rs.upa.cj.p-recepcion.success-cajaUPA").subscribe((res) => { })

          }
          break;
        case "privacy-agreement-step":
          //if user register from social media
          if (e.detail[0].data.access == "register" && e.detail[0].status) {
            this.isUserLoggedIn = true;
            this.isUserAlreadyLogin = true;
            this.submitEmail(e.detail[0].data.email);
            if (!this.isSw) {
              this.submitContract()
            } else {
              this.submitSWContract()
            }

            this.CounterService.processCounter("rs.upa.cj.p-recepcion.success-cajaUPA").subscribe((res) => { })
          }
          break;
        case "access-rrss-step":
          //if user register from social media
          if (e.detail[0].data.access == "register" && e.detail[0].status) {
            this.submitEmail(e.detail[0].data.email);
            this.isUserLoggedIn = true;
            this.isUserAlreadyLogin = true;
            if (!this.isSw) {
              this.submitContract()
            } else {
              this.submitSWContract()
            }

            this.CounterService.processCounter("rs.upa.cj.p-recepcion.success-cajaUPA").subscribe((res) => { })
          }


          break;
        case "create-account-step":
          //if user register from email
          if (e.detail[0].data.access == "register" && e.detail[0].status) {
            this.submitEmail(e.detail[0].data.email);
            this.isUserLoggedIn = true;
            this.isUserAlreadyLogin = true;
            if (!this.isSw) {
              this.submitContract()
            } else {
              this.submitSWContract()
            }

            this.CounterService.processCounter("rs.upa.cj.p-recepcion.success-cajaUPA").subscribe((res) => { })
          }
          break;

      }
      //if get any error during UPA registration process
      if (e.detail.length > 0 && !e.detail[0].status) {
        this.isErrorInLoginOrRegistrationInUPA = true;
        this.CounterService.processCounter("rs.upa.cj.p-recepcion.failure").subscribe((res) => { })
      }
    });
  }

  loginTriggerClick() {
    this.gtmDataLayerUiService.addAnswer("q1", "openupa").subscribe();
  }

  deleteCookieByName(cookies) {
    var domains = ["rastreator.com", "rastreatortest.com"];
    var slitedCookies = cookies.split(',');
    slitedCookies.forEach((cookiename) => {
      domains.forEach((domain) => {
        document.cookie = cookiename + "=" + (("/") ? ";path=" + "/" : "") + ((domain) ? ";domain=" + domain : "") + ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
      })
    })
  }

  openUpaModal() {
    this.addUpaLoginEventListner();
    let upaLogin: any = document.querySelector('webc-login');
    if (upaLogin) {
      upaLogin.vueComponent.openAsModal()
    }
  }

  isItNotYou() {
    this.upaUserProfileDataModel = new UpaUserProfileDataModel();
    this.isUserLoggedIn = true;
    this.isUserAlreadyLogin = false;
    this.gtmDataLayerUiService.addAnswer("qx", "¿no eres tu?").subscribe()
    this.CounterService.processCounter("rs.upa.cj.p-recepcion.success-cajaUPA.c-no-eres-tu").subscribe((res) => { });
    this.deleteCookieByName('verifieduserInfo,verifieduserToken');
    var upaLogin: any = document.querySelector('webc-login');
    if (upaLogin) {
      this.openUpaModal();
    }
  }

  ngOnDestroy(): void {
    if (this.ayudaChannelSubscription) {
      this.ayudaChannelSubscription.unsubscribe();
    }

    if (this.ayudaFormEventSubscription) {
      this.ayudaFormEventSubscription.unsubscribe();
    }
  } 
}
